import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Gallery.css';

const Gallery = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const galleryItems = [
    {
      src: '/entrance.jpeg',
      title: 'Welcoming Entrance',
      description: 'Modern and accessible clinic entrance'
    },
    {
      src: '/treatment.jpeg',
      title: 'Treatment Rooms',
      description: 'State-of-the-art treatment facilities'
    },
    {
      src: '/esthetic.jpeg',
      title: 'Esthetic Clinic',
      description: 'Specialized cosmetic dentistry area'
    },
    {
      src: '/patient.jpeg',
      title: 'Happy Patients',
      description: 'Satisfied patients with beautiful smiles'
    }
  ];

  return (
    <section className="gallery" id="gallery" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2>Our Modern Facility</h2>
          <p>Take a virtual tour of our state-of-the-art dental clinic</p>
        </motion.div>
        
        <div className="gallery-grid">
          {galleryItems.map((item, index) => (
            <motion.div
              key={index}
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <img src={item.src} alt={item.title} />
              <motion.div 
                className="gallery-overlay"
                initial={{ y: '100%' }}
                whileHover={{ y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
